import { isObject } from '../is-object';
export function isProjectSchema(data) {
  if (!isObject(data)) {
    return false;
  }
  return 'componentsTree' in data;
}